import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
export type LoadingSpinnerProps = {
  className?: string;
  color?: 'accent' | 'secondary' | 'tertiary' | 'primary' | 'quinary' | 'translucid';
  ariaLabel?: string;
  size?: 'compact' | 'default' | 'large' | 'xlarge';
  animate?: boolean;
};
const LoadingSpinner = t0 => {
  const $ = _c(28);
  const {
    className,
    color: t1,
    ariaLabel,
    size: t2,
    animate: t3
  } = t0;
  const color = t1 === undefined ? "primary" : t1;
  const size = t2 === undefined ? "default" : t2;
  const animate = t3 === undefined ? true : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keyPrefix: "components.loading-indicator"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t4);
  let t5;
  if ($[1] !== color) {
    t5 = () => {
      if (color === "accent") {
        return "var(--loading-spinner-accent-track)";
      }
      if (color === "quinary") {
        return "var(--loading-spinner-quinary-track)";
      }
      return "var(--border-color-tertiary)";
    };
    $[1] = color;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const getTrackStroke = t5;
  let t6;
  if ($[3] !== className || $[4] !== color || $[5] !== size) {
    t6 = cx("flex items-center justify-center", {
      "text-accent": color === "accent",
      "text-secondary": color === "secondary",
      "text-tertiary": color === "tertiary",
      "text-primary": color === "primary" || color === "translucid",
      "text-quinary": color === "quinary"
    }, {
      "w-3 h-3": size === "compact",
      "w-4 h-4": size === "default",
      "w-5 h-5": size === "large",
      "w-6 h-6": size === "xlarge"
    }, className);
    $[3] = className;
    $[4] = color;
    $[5] = size;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== ariaLabel || $[8] !== t) {
    t7 = ariaLabel || t("aria-label-default");
    $[7] = ariaLabel;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = animate && "animate-spin motion-reduce:animate-none";
  let t9;
  if ($[10] !== t8) {
    t9 = cx("w-full h-full", t8);
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = getTrackStroke();
  const t11 = color === "translucid" ? 0.15 : 1;
  let t12;
  if ($[12] !== t10 || $[13] !== t11) {
    t12 = <circle cx={16} cy={16} r={12} strokeWidth={4} fill="none" stroke={t10} strokeOpacity={t11} />;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = animate && "animate-spinner-dash motion-reduce:animate-none";
  let t14;
  if ($[15] !== t13) {
    t14 = cx("origin-center [transform-box:fill-box]", t13);
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = color === "translucid" ? 0.3 : 1;
  let t16;
  if ($[17] !== t14 || $[18] !== t15) {
    t16 = <circle className={t14} cx={16} cy={16} r={12} stroke="currentColor" strokeWidth={4} strokeLinecap="round" fill="none" strokeDasharray="75 75" strokeOpacity={t15} />;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t12 || $[21] !== t16 || $[22] !== t9) {
    t17 = <svg className={t9} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">{t12}{t16}</svg>;
    $[20] = t12;
    $[21] = t16;
    $[22] = t9;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t17 || $[25] !== t6 || $[26] !== t7) {
    t18 = <div className={t6} aria-label={t7} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={50}>{t17}</div>;
    $[24] = t17;
    $[25] = t6;
    $[26] = t7;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
};
export default LoadingSpinner;